module.exports = __webpack_public_path__ + "img/pms730-logo.4a640b76.png";